import { Component, DOCUMENT, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../language.service';
import { TranslocoService } from '@jsverse/transloco';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'language-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem],
})
export class LanguageSelectorComponent {
  languageService = inject(LanguageService);
  private document = inject(DOCUMENT);

  currentLanguage = this.languageService.currentLanguage;

  private translocoService = inject(TranslocoService);

  constructor() {
    // effect voor html document lang te laten aanpassen
    effect(() => {
      this.document.documentElement.lang = this.currentLanguage();
      this.translocoService.setActiveLang(this.currentLanguage());
    });
  }
}
